// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.discount-card {
  padding: 1rem !important;
  background-color: var(--primary-button-color);
  border-radius: 1.25rem 0 0 1.25rem !important;
  border-right: none !important;
}
.discount-card b {
  color: var(--primary-button-text-color);
}
@media (max-width: 768px) {
  .discount-card {
    padding: 0 1rem 0 1rem !important;
    border-radius: 1rem 1rem 0 0 !important;
    border-bottom: 1px dashed var(--primary-color) !important;
    border-right: 1px solid transparent !important;
  }
}
.discount-card .ant-card-body {
  color: white;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  min-width: 253px;
}
@media (max-width: 768px) {
  .discount-card .ant-card-body {
    border-right: 1px dashed var(--primary-color);
    margin-right: 0 !important;
    flex-direction: row;
    border: none;
    min-width: 1px;
    padding: 1rem 0 1rem 0 !important;
  }
}
@media (max-width: 768px) {
  .discount-card .discount-card-value {
    min-width: inherit;
    width: 100%;
  }
}
.discount-card .discount-value {
  margin-bottom: 0;
  min-width: 234px;
  font-size: 1.25rem;
  color: var(--primary-button-text-color);
  margin: 0px;
}
@media (max-width: 768px) {
  .discount-card .discount-value {
    min-width: 0px;
  }
}
.discount-card .discount-value b {
  font-size: 5.5rem;
  line-height: 100%;
  font-weight: 500;
}
@media (max-width: 768px) {
  .discount-card .discount-value b {
    font-size: 2.5rem;
  }
}
.discount-card .clock,
.discount-card .ant-divider {
  display: none;
}
@media (max-width: 768px) {
  .discount-card .ant-divider {
    display: block;
    border: 0.5px solid var(--primary-button-text-color);
    height: 4.5rem;
    margin-left: 1rem;
    margin-right: 1rem;
  }
  .discount-card .discount-value {
    font-size: 0.875rem;
    line-height: 120%;
    margin-bottom: 0;
  }
  .discount-card .clock {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 0.75rem;
    font-weight: 500;
    width: 100%;
    color: var(--primary-button-text-color);
  }
  .discount-card .clock .promotion-card__clock .anticon {
    font-size: 1.25rem;
    margin-right: 0.5rem;
  }
  .discount-card .clock .promotion-card__clock .ant-statistic {
    line-height: 120%;
  }
  .discount-card .clock .promotion-card__clock .ant-statistic span {
    font-size: 1.25rem;
    font-weight: 500;
    color: var(--primary-button-text-color);
    line-height: 120%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/screens/PromoRenegotiationScreen/Components/HighlightedDiscountCard.less"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,6CAAA;EACA,6CAAA;EACA,6BAAA;AACF;AALA;EAOI,uCAAA;AACJ;AAEE;EAAA;IACE,iCAAA;IACA,uCAAA;IACA,yDAAA;IACA,8CAAA;EACF;AACF;AAhBA;EAkBI,YAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;AACJ;AACI;EAAA;IACE,6CAAA;IACA,0BAAA;IACA,mBAAA;IACA,YAAA;IACA,cAAA;IACA,iCAAA;EAEJ;AACF;AACE;EAAA;IAEI,kBAAA;IACA,WAAA;EACJ;AACF;AA3CA;EA8CI,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,uCAAA;EACA,WAAA;AAAJ;AAEI;EAAA;IACE,cAAA;EACJ;AACF;AAvDA;EAyDM,iBAAA;EACA,iBAAA;EACA,gBAAA;AACN;AACM;EAAA;IACE,iBAAA;EAEN;AACF;AAjEA;;EAoEI,aAAA;AACJ;AAEE;EAAA;IAEI,cAAA;IACA,oDAAA;IACA,cAAA;IACA,iBAAA;IACA,kBAAA;EAAJ;EANA;IAUI,mBAAA;IACA,iBAAA;IACA,gBAAA;EADJ;EAXA;IAgBI,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,kBAAA;IACA,gBAAA;IACA,WAAA;IAEA,uCAAA;EAHJ;EApBA;IA2BQ,kBAAA;IACA,oBAAA;EAJR;EAxBA;IA+BQ,iBAAA;EAJR;EA3BA;IAiCU,kBAAA;IACA,gBAAA;IACA,uCAAA;IACA,iBAAA;EAHV;AACF","sourcesContent":[".discount-card {\n  padding: 1rem !important;\n  background-color: var(--primary-button-color);\n  border-radius: 1.25rem 0 0 1.25rem !important;\n  border-right: none !important;\n  \n  b {\n    color: var(--primary-button-text-color)\n  }\n  \n  @media(max-width: @md-screen) {\n    padding: 0 1rem 0 1rem !important;\n    border-radius: 1rem 1rem 0 0 !important;\n    border-bottom: 1px dashed var(--primary-color) !important; \n    border-right: 1px solid transparent !important;\n  }\n\n  .ant-card-body {\n    color: white;\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n    width: 100%;\n    min-width: 253px;\n    \n    @media(max-width: @md-screen) {\n      border-right: 1px dashed var(--primary-color);\n      margin-right: 0 !important;\n      flex-direction: row;\n      border: none;\n      min-width: 1px;\n      padding: 1rem 0 1rem 0 !important;\n    }\n  }\n\n  @media(max-width: @md-screen) {\n    .discount-card-value {\n      min-width: inherit;\n      width: 100%;\n    }\n  }\n  \n  .discount-value {\n    margin-bottom: 0;      \n    min-width: 234px;\n    font-size: 1.25rem;\n    color: var(--primary-button-text-color);\n    margin: 0px;\n\n    @media(max-width: @md-screen) {\n      min-width: 0px;\n    }\n    \n    b {\n      font-size: 5.5rem;\n      line-height: 100%;\n      font-weight: 500;\n\n      @media(max-width: @md-screen) {\n        font-size: 2.5rem;\n      }\n    }\n  }\n\n  .clock, .ant-divider {\n    display: none;\n  }\n\n  @media(max-width: @md-screen) {\n    .ant-divider {\n      display: block;\n      border: 0.5px solid var(--primary-button-text-color);\n      height: 4.5rem;\n      margin-left: 1rem;\n      margin-right: 1rem;\n    }\n\n    .discount-value {\n      font-size: 0.875rem;\n      line-height: 120%;\n      margin-bottom: 0;\n    }\n    \n    .clock {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      font-size: 0.75rem;\n      font-weight: 500;\n      width: 100%;\n\n      color: var(--primary-button-text-color);\n\n      .promotion-card__clock {\n        .anticon {\n          font-size: 1.25rem;\n          margin-right: 0.5rem;\n        }\n        .ant-statistic {\n          line-height: 120%;\n          span {\n            font-size: 1.25rem;\n            font-weight: 500;\n            color: var(--primary-button-text-color);\n            line-height: 120%;\n          }\n        }\n      }\n    }\n  }\n}\n@xs-screen: 480px;@sm-screen: 576px;@md-screen: 768px;@lg-screen: 992px;@xl-screen: 1200px;@xxl-screen: 1600px;@content-max-width: 1598px;@border-radius: 1.25rem;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
